<div class="m-2">
    <h2>
        {{
            (isEditing
                ? 'company.employees.add-employee.edit-title'
                : 'company.employees.add-employee.title'
            ) | translate
        }}
    </h2>
    <hr />
    <on-loading *ngIf="isLoading"></on-loading>
    <!-- Kept in the DOM while sending so a failure does not lose the profile -->
    <div class="flex-row" [hidden]="isLoading">
        <!-- <MODE> -->
        <div class="btn-group mb-3" *ngIf="!isEditing">
            <button
                type="button"
                class="btn btn-sm"
                [class.btn-primary]="mode === 'bulk'"
                [class.btn-outline-primary]="mode !== 'bulk'"
                (click)="switchMode('bulk')"
            >
                {{ 'company.employees.add-employee.mode-bulk' | translate }}
            </button>
            <button
                type="button"
                class="btn btn-sm"
                [class.btn-primary]="mode === 'single'"
                [class.btn-outline-primary]="mode !== 'single'"
                (click)="switchMode('single')"
            >
                {{ 'company.employees.add-employee.mode-single' | translate }}
            </button>
        </div>
        <!-- </MODE> -->

        <div
            *ngIf="isEditing"
            [innerHTML]="
                'company.employees.add-employee.edit-description' | translate
            "
            class="alert alert-info"
        ></div>

        <!-- <EMAILS> -->
        <ng-container *ngIf="mode === 'bulk'">
            <div
                [innerHTML]="
                    'company.employees.add-employee.description' | translate
                "
            ></div>
            <div>
                <textarea
                    [(ngModel)]="employeesText"
                    rows="10"
                    class="form-control"
                ></textarea>
            </div>
        </ng-container>
        <div class="form-group" *ngIf="mode === 'single'">
            <label for="single-email">{{
                'company.employees.add-employee.single-email' | translate
            }}</label>
            <input
                type="email"
                class="form-control"
                id="single-email"
                [(ngModel)]="singleEmail"
                [readonly]="isEditing"
            />
        </div>
        <!-- </EMAILS> -->

        <div
            class="alert alert-danger ml-4 mr-4"
            *ngIf="incorrectEmails && incorrectEmails.length"
        >
            {{
                'company.employees.add-employee.not-valid-emails'
                    | translate: { emails: incorrectEmails.join(', ') }
            }}
        </div>

        <!-- <PROFILE> -->
        <div class="mt-3" *ngIf="mode === 'bulk'">
            <div class="custom-control custom-switch custom-switch-md">
                <input
                    type="checkbox"
                    class="custom-control-input"
                    id="show-prefill"
                    [(ngModel)]="showPrefill"
                />
                <label class="custom-control-label" for="show-prefill">{{
                    'company.employees.add-employee.prefill.toggle' | translate
                }}</label>
            </div>
        </div>

        <on-invitation-prefill-form
            *ngIf="mode === 'single' || showPrefill"
            [allEmployees]="allEmployees"
            [showPersonalFields]="mode === 'single'"
            [prefill]="prefillToEdit"
        >
        </on-invitation-prefill-form>
        <!-- </PROFILE> -->

        <div class="text-center mt-3">
            <button
                class="btn btn-primary"
                [disabled]="isLoading"
                (click)="save()"
            >
                {{
                    (isEditing
                        ? 'company.employees.add-employee.edit-btn'
                        : 'company.employees.add-employee.btn'
                    ) | translate
                }}
            </button>
        </div>
    </div>
</div>
